import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'itemName',
	standalone: true
})
export class ItemNamePipe implements PipeTransform {

	/**
	 * @description Used to replace some special characters in item names
	 **/
	transform(value: string) {
		if (value) {
			return value.replace('&amp;', '&').replace('&#8211;', '-');
		}

		return '';
	}
}
